'use strict';

var variables = {
  'background-primary': 'var(--background-primary)',
  'background-secondary': 'var(--background-secondary)',
  'background-tertiary': 'var(--background-tertiary)',
  'background-disabled': 'var(--background-disabled)',
  'background-accent': 'var(--background-accent)',
  'background-brand': 'var(--background-brand)',
  'text-and-icon-primary': 'var(--text-and-icon-primary)',
  'text-and-icon-secondary': 'var(--text-and-icon-secondary)',
  'text-and-icon-oncolor': 'var(--text-and-icon-oncolor)',
  'text-and-icon-disabled': 'var(--text-and-icon-disabled)',
  'text-and-icon-accent': 'var(--text-and-icon-accent)',
  'border-primary': 'var(--border-primary)',
  'border-disabled': 'var(--border-disabled)',
  'extensions-text-and-icon-error': 'var(--extensions-text-and-icon-error)',
  'extensions-background-surface': 'var(--extensions-background-surface)',
  'extensions-text-and-icon-warning': 'var(--extensions-text-and-icon-warning)',
  'extensions-background-inverseprimary': 'var(--extensions-background-inverseprimary)',
  'extensions-text-and-icon-success': 'var(--extensions-text-and-icon-success)',
  'extensions-background-overlaydark': 'var(--extensions-background-overlaydark)',
  'extensions-background-overlaylight': 'var(--extensions-background-overlaylight)',
  'extensions-text-and-icon-alwaysdark': 'var(--extensions-text-and-icon-alwaysdark)',
  'extensions-background-alwaysdark': 'var(--extensions-background-alwaysdark)',
  'extensions-text-and-icon-alwayslight': 'var(--extensions-text-and-icon-alwayslight)',
  'extensions-text-and-icon-onbrand': 'var(--extensions-text-and-icon-onbrand)',
  'extensions-background-alwayslight': 'var(--extensions-background-alwayslight)',
  'extensions-background-error': 'var(--extensions-background-error)',
  'extensions-border-accent': 'var(--extensions-border-accent)',
  'extensions-background-warning': 'var(--extensions-background-warning)',
  'extensions-border-error': 'var(--extensions-border-error)',
  'extensions-background-success': 'var(--extensions-background-success)',
  'extensions-border-success': 'var(--extensions-border-success)',
  'extensions-background-lightsuccess': 'var(--extensions-background-lightsuccess)',
  'extensions-background-lightaccent': 'var(--extensions-background-lightaccent)',
  'extensions-background-lighterror': 'var(--extensions-background-lighterror)',
  'extensions-background-lightwarning': 'var(--extensions-background-lightwarning)',
  'extensions-background-control': 'var(--extensions-background-control)',
  'statement-background-primarypressed': 'var(--statement-background-primarypressed)',
  'statement-background-secondarypressed': 'var(--statement-background-secondarypressed)',
  'statement-background-tertiarypressed': 'var(--statement-background-tertiarypressed)',
  'statement-background-successpressed': 'var(--statement-background-successpressed)',
  'statement-background-brandpressed': 'var(--statement-background-brandpressed)',
  'statement-background-lightsuccesspressed': 'var(--statement-background-lightsuccesspressed)',
  'statement-background-accentpressed': 'var(--statement-background-accentpressed)',
  'statement-background-lightaccentpressed': 'var(--statement-background-lightaccentpressed)',
  'statement-background-errorpressed': 'var(--statement-background-errorpressed)',
  'statement-background-lighterrorpressed': 'var(--statement-background-lighterrorpressed)',
  'statement-background-warningpressed': 'var(--statement-background-warningpressed)',
  'statement-background-lightwarningpressed': 'var(--statement-background-lightwarningpressed)',
  'statement-background-additional01pressed': 'var(--statement-background-additional01pressed)',
  'statement-background-additional04pressed': 'var(--statement-background-additional04pressed)',
  'statement-background-inverseprimarypressed': 'var(--statement-background-inverseprimarypressed)',
  'statement-background-alwayslightpressed': 'var(--statement-background-alwayslightpressed)',
  'statement-background-controlpressed': 'var(--statement-background-controlpressed)',
  'statement-text-and-icon-primarypressed': 'var(--statement-text-and-icon-primarypressed)',
  'statement-text-and-icon-secondarypressed': 'var(--statement-text-and-icon-secondarypressed)',
  'statement-text-and-icon-oncolorpressed': 'var(--statement-text-and-icon-oncolorpressed)',
  'statement-text-and-icon-successpressed': 'var(--statement-text-and-icon-successpressed)',
  'statement-text-and-icon-accentpressed': 'var(--statement-text-and-icon-accentpressed)',
  'statement-text-and-icon-errorpressed': 'var(--statement-text-and-icon-errorpressed)',
  'statement-text-and-icon-warningpressed': 'var(--statement-text-and-icon-warningpressed)',
  'statement-text-and-icon-alwaysdarkpressed': 'var(--statement-text-and-icon-alwaysdarkpressed)',
  'statement-text-and-icon-onbrandpressed': 'var(--statement-text-and-icon-onbrandpressed)',
  'statement-border-primarypressed': 'var(--statement-border-primarypressed)',
  'statement-border-successpressed': 'var(--statement-border-successpressed)',
  'statement-border-accentpressed': 'var(--statement-border-accentpressed)',
  'statement-border-errorpressed': 'var(--statement-border-errorpressed)',
  'statement-border-focused': 'var(--statement-border-focused)',
  'additional-background-additional01': 'var(--additional-background-additional01)',
  'additional-background-additional02': 'var(--additional-background-additional02)',
  'additional-background-additional03': 'var(--additional-background-additional03)',
  'additional-background-additional04': 'var(--additional-background-additional04)',
  'additional-background-additional05': 'var(--additional-background-additional05)',
  'additional-background-additional06': 'var(--additional-background-additional06)',
  'additional-background-additional07': 'var(--additional-background-additional07)',
  'additional-background-additional08': 'var(--additional-background-additional08)',
  'additional-background-progressbuttonbrand': 'var(--additional-background-progressbuttonbrand)',
  'additional-background-progressbuttonaccent': 'var(--additional-background-progressbuttonaccent)',
  'additional-background-splashscreen': 'var(--additional-background-splashscreen)',
  'additional-shadow-primary': 'var(--additional-shadow-primary)',
  'additional-skeleton-start': 'var(--additional-skeleton-start)',
  'additional-skeleton-end': 'var(--additional-skeleton-end)',
  'information-light-brandlight': 'var(--information-light-brandlight)',
  'information-light-sandlight': 'var(--information-light-sandlight)',
  'information-light-earthlight': 'var(--information-light-earthlight)',
  'information-light-waterlight': 'var(--information-light-waterlight)',
  'information-light-airlight': 'var(--information-light-airlight)',
  'information-light-windlight': 'var(--information-light-windlight)',
  'information-light-stormlight': 'var(--information-light-stormlight)',
  'information-light-senselight': 'var(--information-light-senselight)',
  'information-light-firelight': 'var(--information-light-firelight)',
  'information-light-crablight': 'var(--information-light-crablight)',
  'information-light-whalelight': 'var(--information-light-whalelight)',
  'information-light-chicklight': 'var(--information-light-chicklight)',
  'information-light-pandalight': 'var(--information-light-pandalight)',
  'information-medium-brandmedium': 'var(--information-medium-brandmedium)',
  'information-medium-sandmedium': 'var(--information-medium-sandmedium)',
  'information-medium-earthmedium': 'var(--information-medium-earthmedium)',
  'information-medium-watermedium': 'var(--information-medium-watermedium)',
  'information-medium-airmedium': 'var(--information-medium-airmedium)',
  'information-medium-windmedium': 'var(--information-medium-windmedium)',
  'information-medium-stormmedium': 'var(--information-medium-stormmedium)',
  'information-medium-sensemedium': 'var(--information-medium-sensemedium)',
  'information-medium-firemedium': 'var(--information-medium-firemedium)',
  'information-medium-crabmedium': 'var(--information-medium-crabmedium)',
  'information-medium-whalemedium': 'var(--information-medium-whalemedium)',
  'information-medium-chickmedium': 'var(--information-medium-chickmedium)',
  'information-medium-pandamedium': 'var(--information-medium-pandamedium)',
  'information-dark-branddark': 'var(--information-dark-branddark)',
  'information-dark-sanddark': 'var(--information-dark-sanddark)',
  'information-dark-earthdark': 'var(--information-dark-earthdark)',
  'information-dark-waterdark': 'var(--information-dark-waterdark)',
  'information-dark-airdark': 'var(--information-dark-airdark)',
  'information-dark-winddark': 'var(--information-dark-winddark)',
  'information-dark-stormdark': 'var(--information-dark-stormdark)',
  'information-dark-sensedark': 'var(--information-dark-sensedark)',
  'information-dark-firedark': 'var(--information-dark-firedark)',
  'information-dark-crabdark': 'var(--information-dark-crabdark)',
  'information-dark-whaledark': 'var(--information-dark-whaledark)',
  'information-dark-chickdark': 'var(--information-dark-chickdark)',
  'information-dark-pandadark': 'var(--information-dark-pandadark)',
  'container-disabled': 'var(--container-disabled)',
  'border-selected': 'var(--border-selected)',
  'programs-background-rewardstier1': 'var(--programs-background-rewardstier1)',
  'programs-background-rewardstier1surface': 'var(--programs-background-rewardstier1surface)',
  'programs-background-rewardstier2': 'var(--programs-background-rewardstier2)',
  'programs-background-rewardstier2surface': 'var(--programs-background-rewardstier2surface)',
  'line-height-xxs': 'var(--line-height-xxs)',
  'line-height-xs': 'var(--line-height-xs)',
  'line-height-s': 'var(--line-height-s)',
  'line-height-m': 'var(--line-height-m)',
  'line-height-ml': 'var(--line-height-ml)',
  'line-height-l': 'var(--line-height-l)',
  'line-height-xl': 'var(--line-height-xl)',
  'line-height-xxl': 'var(--line-height-xxl)',
  'line-height-xxxl': 'var(--line-height-xxxl)',
  'font-size-xxs': 'var(--font-size-xxs)',
  'font-size-xs': 'var(--font-size-xs)',
  'font-size-s': 'var(--font-size-s)',
  'font-size-m': 'var(--font-size-m)',
  'font-size-ml': 'var(--font-size-ml)',
  'font-size-l': 'var(--font-size-l)',
  'font-size-xl': 'var(--font-size-xl)',
  'font-size-xxl': 'var(--font-size-xxl)',
  'font-size-xxxl': 'var(--font-size-xxxl)',
  'font-weight-normal': 'var(--font-weight-normal)',
  'font-weight-regular': 'var(--font-weight-regular)',
  'font-weight-medium': 'var(--font-weight-medium)',
  'font-weight-semi-bold': 'var(--font-weight-semi-bold)',
  'font-weight-bold': 'var(--font-weight-bold)',
  'font-family-noto': 'var(--font-family-noto)',
  'font-family-landing': 'var(--font-family-landing)',
  'spacers-none': 'var(--spacers-none)',
  'spacers-3xs': 'var(--spacers-3xs)',
  'spacers-2xs': 'var(--spacers-2xs)',
  'spacers-xs': 'var(--spacers-xs)',
  'spacers-s': 'var(--spacers-s)',
  'spacers-m': 'var(--spacers-m)',
  'spacers-l': 'var(--spacers-l)',
  'spacers-xl': 'var(--spacers-xl)',
  'spacers-2xl': 'var(--spacers-2xl)',
  'spacers-3xl': 'var(--spacers-3xl)',
  'spacers-4xl': 'var(--spacers-4xl)',
  'spacers-5xl': 'var(--spacers-5xl)',
  'spacers-6xl': 'var(--spacers-6xl)',
  'spacers-7xl': 'var(--spacers-7xl)',
  'spacers-8xl': 'var(--spacers-8xl)',
  'spacers-9xl': 'var(--spacers-9xl)',
  'shadow-s': 'var(--shadow-s)',
  'shadow-m': 'var(--shadow-m)',
  'shadow-l': 'var(--shadow-l)'
};

exports.variables = variables;
